import React, { useContext, useMemo } from "react";
import { Navigate, Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/sidebar/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/navbar/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer";
import Settings from "../components/Settings";
import useAuth from "hooks/useAuth";
import NotyfContext from "contexts/NotyfContext";
import { HelperButtons } from "components/HelperButtons";
import { faFileExport, faLink } from "@fortawesome/free-solid-svg-icons";

const PrivateLayout = ({ children }) => {
  const { isAuthenticated, isInitialized, user, menus } = useAuth();
  const notyf = useContext(NotyfContext);

  // Check if user should see IntelliBuild link
  const shouldShowIntelliBuild =
    user?.email &&
    (user.email.endsWith("@fondaglobal.com") ||
      user.email.endsWith("@intellisolution.tech"));

  const dynamicNavItems = useMemo(() => {
    if (!menus) return null;

    const updatedMenus = [...menus];

    if (shouldShowIntelliBuild) {
      updatedMenus.push({
        icon: faLink,
        title: "Go to IntelliWorkflow",
        href: "https://app.intellibuild.net",
        external: true,
      });
    }

    return [
      {
        title: "Pages",
        pages: updatedMenus,
      },
    ];
  }, [menus, shouldShowIntelliBuild]);

  if (isInitialized && !isAuthenticated) {
    notyf.open({
      type: "danger",
      message:
        "Unauthorized: Access is denied, please login again with valid credentials.",
    });
    return (
      <Navigate
        to="/auth/sign-in"
        state={{
          page_redirect: window.location.href,
        }}
      />
    );
  }

  return (
    <React.Fragment>
      {isAuthenticated && (
        <>
          <Wrapper>
            {dynamicNavItems && <Sidebar items={dynamicNavItems} />}
            <Main>
              <Navbar user={user} />
              <Content>
                {children}
                <Outlet />
              </Content>
              <Footer />
            </Main>
          </Wrapper>
          <Settings />
          <HelperButtons />
        </>
      )}
    </React.Fragment>
  );
};

export default PrivateLayout;
